export const PERMISSION_KEYS = {
  NEW_POST: 'NEW_POST',
  HOME: 'HOME',
  FOLLOWING: 'FOLLOWING',
  DISCOVER: 'DISCOVER',
  SAVED: 'SAVED',
  COURSES: 'COURSES',
  ACTIVITY: 'ACTIVITY',
  MESSAGES: 'MESSAGES',
  LOCK_MESSAGE: 'LOCK_MESSAGE',
  SHOW_OPTIONS: 'SHOW_OPTIONS',
  AUTOMATED_MESSAGES: 'AUTOMATED_MESSAGES',
  CREATORS: 'CREATORS',
  COLLABORATORS: 'COLLABORATORS',
  MONETIZE: 'MONETIZE',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  EXPERIENCES: 'EXPERIENCES',
  MERCHANDISES: 'MERCHANDISES',
  NFT: 'NFT',
  VIP_OFFERS: 'VIP_OFFERS',
  REFERRALS: 'REFERRALS',
  EVENT_CALENDAR: 'EVENT_CALENDAR',
  WALLET: 'WALLET',
  TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
  ORDER_HISTORY: 'ORDER_HISTORY',
  SUBSCRIPTION_PLANS: 'SUBSCRIPTION_PLANS',
  CURRENT_BALANCE: 'CURRENT_BALANCE',
  W9_FORM: 'W9-FORM',
  INSIGHTS: 'INSIGHTS',
  EARNING_METRICS: 'EARNING_METRICS',
  ENGAGEMENT_METRICS: 'ENGAGEMENT_METRICS',
  USER_SEGMENTATION: 'USER_SEGMENTATION',
  EDIT_PREFERENCES: 'EDIT_PREFERENCES',
  PROFILE: 'PROFILE',
  SITE_EXPERIENCE: 'SITE_EXPERIENCE',
  NOTIFICATIONS: 'NOTIFICATIONS',
  WHITE_LABELED_SITE: 'WHITE_LABELED_SITE',
  PRIVACY_AND_PASSWORD: 'PRIVACY_AND_PASSWORD',
  CREATOR_TYPES: 'CREATOR_TYPES',
  PAUSE_ACCOUNT: 'PAUSE_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  MONETIZATION: 'MONETIZATION',
  NFT_WALLET: 'NFT_WALLET',
  CHATROOM: 'CHATROOM',
  LEADERBOARD: 'LEADERBOARD',
  MY_POST: 'MY_POST',
  DISPLAY_IN_CREATOR_DIRECTORY: 'DISPLAY_IN_CREATOR_DIRECTORY',
  REFUND_REQUEST: 'REFUND_REQUEST',
  FULFILLMENT_REQUEST: 'FULFILLMENT_REQUEST',
  DELEGATION: 'DELEGATION',
  PORTFOLIO: 'PORTFOLIO',
  ACCESS_USER_SEGMENTATION: 'ACCESS_USER_SEGMENTATION',
  FAN_RELATIONSHIP_MANAGEMENT: 'FAN_RELATIONSHIP_MANAGEMENT',
  FAN_MANAGEMENT: 'FAN_MANAGEMENT',
  VIEW_MY_WALLET_BALANCE: 'VIEW_MY_WALLET_BALANCE',
  VIEW_TRANSACTION_HISTORY: 'VIEW_TRANSACTION_HISTORY',
  VIEW_REFERRALS: 'VIEW_REFERRALS',
  VIEW_EARNING_METRICS: 'VIEW_EARNING_METRICS',
  WITHDRAW_MONEY_TO_MY_BANK_ACCOUNT: 'WITHDRAW_MONEY_TO_MY_BANK_ACCOUNT',
  ADD_REMOVE_BANK_ACCOUNT_AND_CREDIT_CARD:
    'ADD_REMOVE_BANK_ACCOUNT_AND_CREDIT_CARD',
  ADD_FUND_TO_THE_WALLET: 'ADD_FUND_TO_THE_WALLET',
  MAKE_EDIT_FEED_POSTS:'MAKE_EDIT_FEED_POSTS',
  MAKE_EDIT_CHAT_ROOM_POSTS:'MAKE_EDIT_CHAT_ROOM_POSTS',
  SEND_REPLY_TO_DIRECT_MESSAGES:'SEND_REPLY_TO_DIRECT_MESSAGES',
  ADD_EDIT_SUBSCRIPTION_ITEMS:'ADD_EDIT_SUBSCRIPTION_ITEMS',
  ADD_EDIT_STORE_ITEMS_VIP_OFFERS_AND_EVENTS:'ADD_EDIT_STORE_ITEMS_VIP_OFFERS_AND_EVENTS',
  MAKE_COMMENTS_ON_FEED_AND_CHAT_ROOMS:'MAKE_COMMENTS_ON_FEED_AND_CHAT_ROOMS',
  VIEW_ENGAGEMENT_METRICS:'VIEW_ENGAGEMENT_METRICS',
  VIEW_FULFILLMENT_REQUESTS:'VIEW_FULFILLMENT_REQUESTS',
  VIEW_AND_ISSUE_REFUND_REQUESTS:'VIEW_AND_ISSUE_REFUND_REQUESTS',
  EDIT_MY_PREFERENCES:'EDIT_MY_PREFERENCES',
  WELCOME_MESSAGE: 'WELCOME_MESSAGE',
  RESOURCES: 'RESOURCES',
  ANNOUNCEMENTS: 'ANNOUNCEMENTS',
  TIP_TUTORIALS: 'TIP_TUTORIALS',
  SERVICE_PROVIDERS: 'SERVICE_PROVIDERS',
  DISCOUNT_CODES: 'DISCOUNT_CODES',
  LINK_IN_BIO: 'LINK_IN_BIO'
};
